import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mediaRef", "recordingUrl", "status", "videoPlayerOptions"];
let _ = t => t,
  _t,
  _t2;
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useState } from 'react';
import { getParsedPlayerStatuses } from '../../utils/getParsedPlayerStatuses';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { LoadingDots } from 'foundations-components/transitional/components/LoadingDots';
import { View } from 'foundations-components/components/View';
import styledWithTheme from 'foundations-theming/utils';
import { EnlargeIcon } from 'foundations-assets/icons/components/EnlargeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledVideoContainer = styledWithTheme.div(_t || (_t = _`
  position: relative;
  width: 100%;
  margin-bottom: ${0};
`), ({
  theme
}) => theme.space['500']);
const StyledVideo = styledWithTheme.video(_t2 || (_t2 = _`
  display: block;
  width: 100%;
  max-height: ${0}px;
`), ({
  maxHeight
}) => maxHeight);
export const VideoElementWrapper = _ref => {
  var _videoPlayerOptions$m;
  let {
      mediaRef,
      recordingUrl,
      status,
      videoPlayerOptions
    } = _ref,
    mediaElementEvents = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [showVisibilityOptions, setShowVisibilityOptions] = useState(false);
  const {
    isLoaded,
    isError
  } = getParsedPlayerStatuses(status);
  const handleFullScreenClick = () => {
    const videoElement = mediaRef && mediaRef.current;
    if (videoElement && videoElement.requestFullscreen) {
      videoElement.requestFullscreen();
    } else if (videoElement && videoElement.webkitRequestFullscreen) {
      videoElement.webkitRequestFullscreen();
    }
  };
  return /*#__PURE__*/_jsxs(StyledVideoContainer, {
    "data-test-id": "videoPlayer-container",
    onMouseOver: () => setShowVisibilityOptions(true),
    onMouseLeave: () => setShowVisibilityOptions(false),
    children: [isLoaded ? null : /*#__PURE__*/_jsx(View, {
      "data-test-id": "videoPlayer-loadingState",
      position: "absolute",
      inset: "0",
      backgroundColor: "fill-accent-neutral-default",
      children: isError ? null : /*#__PURE__*/_jsx(LoadingDots, {})
    }), /*#__PURE__*/_jsx(StyledVideo, Object.assign({
      maxHeight: (_videoPlayerOptions$m = videoPlayerOptions === null || videoPlayerOptions === void 0 ? void 0 : videoPlayerOptions.maxHeight) !== null && _videoPlayerOptions$m !== void 0 ? _videoPlayerOptions$m : 250,
      "data-test-id": "mediaContext-videoElement",
      preload: "auto",
      src: recordingUrl,
      ref: mediaRef
    }, mediaElementEvents)), showVisibilityOptions && /*#__PURE__*/_jsx(View, {
      "data-test-id": "videoPlayer-visibilityOptions",
      position: "absolute",
      insetInlineEnd: "200",
      insetBlockEnd: "200",
      children: /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "videoPlayer-expandButton",
        use: "tertiary",
        onClick: handleFullScreenClick,
        children: /*#__PURE__*/_jsx(EnlargeIcon, {})
      })
    })]
  });
};